import { __extends } from 'tslib';
import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import schema from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/config.schema.json';

var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message, errors) {
        var _this = this;
        var errorDetails = errors
            .map(function (error) {
            return "- ".concat(error.instancePath || '/', ": ").concat(error.message, " ").concat(error.params ? "(".concat(JSON.stringify(error.params), ")") : '');
        })
            .join('\n');
        _this = _super.call(this, "".concat(message, ":\n").concat(errorDetails)) || this;
        _this.errors = errors;
        _this.name = 'ValidationError';
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ValidationError);
        }
        // Fix the prototype chain for instanceof checks
        Object.setPrototypeOf(_this, ValidationError.prototype);
        return _this;
    }
    return ValidationError;
}(Error));
// Create and configure Ajv instance
var ajv = new Ajv({
    allErrors: true, // Collect all errors, not just the first
    verbose: true, // Include error data paths
    strict: true, // Catch more erroring conditions
    allowMatchingProperties: true, // Allow property pattern matching
    allowUnionTypes: true, // Allow multiple types in a single schema
});
// Add support for URI format validation
addFormats(ajv);
// Create typed validator
var validateConfig = ajv.compile(schema);
var validateConfiguration = function (config) {
    var isValid = validateConfig(config);
    if (!isValid) {
        throw new ValidationError('Configuration validation failed', validateConfig.errors || []);
    }
    return config;
};

export { ValidationError, validateConfiguration };
